import { Product, ProductSource } from "@/Contracts/Products";

export const isProductFromEtilize = (
	product?: Product | null,
	hasSelfProductCheck = true
): boolean =>
	!!product?.pricing?.find(
		pricing =>
			pricing.item_id?.startsWith(ProductSource.Etilize) ||
			pricing.item_id?.startsWith(ProductSource.Icecat) ||
			(hasSelfProductCheck && pricing.item_id?.startsWith("distributor"))
	);
